import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_address_edit = _resolveComponent("van-address-edit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "编辑回寄地址" }),
    _createVNode(_component_van_address_edit, {
      class: "fault-address-box",
      "area-list": _ctx.areaList,
      "show-set-default": "",
      "address-info": _ctx.addressInfo,
      "save-button-text": "保存并使用",
      onSave: _ctx.onSave
    }, null, 8, ["area-list", "address-info", "onSave"])
  ], 64))
}